import useRoleLabel from 'helpers/useRoleLabel'

import UserLink from 'js/components/UserLink'
import displayProfileField from 'js/lib/helpers/displayProfileField'

import styles from './User.module.css'

const User = ({ entity }) => (
    <tr className={styles.wrapper}>
        <td>
            <UserLink
                entity={entity}
                role={useRoleLabel(entity.roles)}
                style={{ height: '100%' }}
            />
        </td>

        {entity.fieldsInOverview.map(({ key, value, fieldType }) => (
            <td key={key}>{value && displayProfileField(value, fieldType)}</td>
        ))}
    </tr>
)

export default User
